import React from 'react';
import { motion } from 'framer-motion';
import { TOMOS } from './salesData';
import { PHOTOS } from '../data/photos';

/** Una foto de resultado por tomo: se ve de un vistazo qué contiene cada uno. */
const TOMO_PHOTOS: Record<string, {
  src: string;
  alt: string;
}> = {
  '1': {
    src: PHOTOS.tomo1,
    alt: 'Jabones naturales con avena y hierbas para el día a día'
  },
  '2': {
    src: PHOTOS.tomo2,
    alt: 'Jabones con carbón, aloe y arcillas para cuidados específicos'
  },
  '3': {
    src: PHOTOS.tomo3,
    alt: 'Jabones decorativos marmolados y con formas'
  },
  '4': {
    src: PHOTOS.tomo4,
    alt: 'Jabones envueltos como souvenirs y sets de regalo'
  }
};
export function TomosSection() {
  return <section id="tomos" className="bg-cream py-11 sm:py-14" data-id="element-260" data-mp="1bc5m4n0wmhxw">
      <div className="mx-auto max-w-md px-5 sm:max-w-3xl" data-id="element-261" data-mp="1bdgp4kmizlny">
        <div className="text-center" data-id="element-262" data-mp="2ht0tngfb9fvw">
          <h2 className="font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:text-[2rem]" data-id="element-263" data-mp="2hrzht9qh0pd4">
            200 fórmulas en <span className="text-gold-deep" data-id="element-264" data-mp="2qnysrsrx1fbd">4 tomos</span>
          </h2>
        </div>

        <ol className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-265" data-mp="2mmnbcaj740e9">
          {TOMOS.map((tomo, i) => {
          const photo = TOMO_PHOTOS[tomo.num];
          return <motion.li key={tomo.num} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.24,
            ease: [0.23, 1, 0.32, 1],
            delay: Math.min(i, 3) * 0.04
          }} className="flex items-center gap-3 overflow-hidden rounded-xl border border-stone bg-white p-2 pr-3.5" data-id="element-266" data-mp="2hlpk78g7jw0m" data-mpi={i}>
                <img src={photo.src} alt={photo.alt} loading="lazy" decoding="async" className="h-16 w-16 shrink-0 rounded-lg object-cover sm:h-[4.5rem] sm:w-[4.5rem]" data-id="element-267" data-mp="1tyhp1jchu3cb" />
                <div className="min-w-0" data-id="element-268" data-mp="1ac65ao3zx9nm">
                  <span className="font-display text-[0.6rem] font-bold uppercase tracking-[0.1em] text-gold-deep" data-id="element-269" data-mp="1ab4v0lut0r6y">
                    Tomo {tomo.num}
                  </span>
                  <h3 className="mt-0.5 font-display text-[0.84rem] font-bold leading-tight text-charcoal" data-id="element-270" data-mp="11bzrt28as9og">
                    {tomo.title}
                  </h3>
                  <p className="mt-0.5 font-sans text-[0.74rem] font-medium tabular-nums text-taupe" data-id="element-271" data-mp="15ewilg7zrc3h">
                    {tomo.range}
                  </p>
                </div>
              </motion.li>;
        })}
        </ol>

        <p className="mt-4 text-center font-display text-[0.7rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-272" data-mp="1kb5fwc8bnfd9">
          50 fórmulas por tomo
        </p>
      </div>
    </section>;
}